// extracted by mini-css-extract-plugin
module.exports = {"container":"ImageAndTextBlock_container__aoz5l","text":"ImageAndTextBlock_text__YOkv2","image":"ImageAndTextBlock_image__kBh5j"};